module.exports = __webpack_public_path__ + "media/images/cureus_logo_small-0ebfc6a4cc973c38b81b511cee1f53d9.png";